(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('HaqTracksDeleteController', HaqTracksDeleteController);

    HaqTracksDeleteController.$inject = ['$uibModalInstance', 'entity', 'HaqTracksService'];

    function HaqTracksDeleteController($uibModalInstance, entity, HaqTracksService) {
        var vm = this;
        vm.haqTrack = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            HaqTracksService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
